







import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";

@Component
export default class HomeMiddleWareHouses extends AbpBase {
  tableHeight=330
  list=[];
  async getWarning(){
   this.list=await this.$store.dispatch({
      type:"thdata/getWarning",
    });
    //console.log(list);
  }
  created() {
    this.getWarning();
  }

  mounted() { 
    this.tableHeight=this.$refs.refwarningmain.offsetHeight-40;
  }
  columns1= [
    {
      title: "库房",
      key: "wName",
    },
    {
      title: "楼层",
      key: "fName",
    },
    {
      title: "位置",
      key: "locationName",
    }
    ,
    {
      title: "温度",
      key: "temp",
    },
    {
      title: "湿度",
      key: "humi",
    }
  ]
}
